import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PhoneCallPinLayout = function PhoneCallPinLayout(_ref) {
  var pinInput = _ref.pinInput,
    errorMessage = _ref.errorMessage;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles['number-container'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles['number-prefix'],
        children: ["+7(", /*#__PURE__*/_jsx("div", {
          className: styles['dots'],
          children: "\u2022\u2022\u2022"
        }), ")", /*#__PURE__*/_jsx("div", {
          className: cn(styles['dots'], styles['dots--after-bracket']),
          children: "\u2022\u2022\u2022"
        })]
      }), pinInput]
    }), errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error-message'],
      children: errorMessage
    })]
  });
};